module.exports = __webpack_public_path__ + "img/yama.f718b4f6.png";